module.exports = "/assets/data/942941da6741c47477cf4591f02ebb36-NR10.data.json";